import { render, staticRenderFns } from "./RtaDetails.vue?vue&type=template&id=3fc34402&scoped=true"
import script from "./RtaDetails.vue?vue&type=script&lang=js"
export * from "./RtaDetails.vue?vue&type=script&lang=js"
import style0 from "./RtaDetails.vue?vue&type=style&index=0&id=3fc34402&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc34402",
  null
  
)

export default component.exports